interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-refresh-line text-base" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}